/**
 * react-easy-crop Area → Canvas 크롭 Blob/File.
 */
import type { Area } from 'react-easy-crop';

const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.crossOrigin = 'anonymous';
    image.src = url;
  });

export const getCroppedImageFile = async (
  imageSrc: string,
  cropArea: Area,
  fileName = 'cropped.jpg',
  mimeType = 'image/jpeg',
  quality = 1,
): Promise<File> => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas를 사용할 수 없습니다.');

  const { width, height, x, y } = cropArea;
  canvas.width = Math.max(1, Math.round(width));
  canvas.height = Math.max(1, Math.round(height));

  ctx.drawImage(
    image,
    x,
    y,
    width,
    height,
    0,
    0,
    canvas.width,
    canvas.height,
  );

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (result) => {
        if (!result) reject(new Error('크롭 이미지 생성에 실패했습니다.'));
        else resolve(result);
      },
      mimeType,
      quality,
    );
  });

  return new File([blob], fileName, {
    type: mimeType,
    lastModified: Date.now(),
  });
};
